<template>
  <DialogBaseWhite :show="showDialogCreateMADTemplate" :title="$t('MADTemplate.createNewMADTemplate') | capitalize" @on-close="closeDialogCreateMADTemplate">
    <template v-slot:content>
      <MADTemplate @on-cancel="onCancel" @on-submit="onSubmit" :template="template"/>
    </template>
  </DialogBaseWhite>
</template>

<script>
import DialogBaseWhite from "components/dialog/base/DialogBaseWhite";
import MADTemplate from "components/form/MADTemplate";
import {mapActions, mapState} from "vuex";
export default {
  name: "DialogCreateMADTemplate",
  components: {MADTemplate, DialogBaseWhite},
  data() {
    return {
      template: {
        title: "",
        content: ""
      }
    }
  },
  computed: {
    ...mapState('dialog', ['showDialogCreateMADTemplate']),
  },
  methods: {
    ...mapActions('dialog', ['closeDialogCreateMADTemplate']),
    ...mapActions('madTemplate', ['createMADTemplate']),
    onCancel() {
      this.closeDialogCreateMADTemplate()
    },
    onSubmit(form) {
      this.createMADTemplate(form)
    }
  }
}
</script>

<style scoped>

</style>
